import { openKakaoLink } from '../utils';
import { TextVariant } from './types';

export const REWARD_INFO_CONSTANTS: Record<string, TextVariant> = {
  onlineSatelliteTitle: { common: '온라인 새틀라이트' },
  onlineDate: {
    common: (
      <>
        3월 16일(월) ~ 3월 27일(금) <br />
        <span>
          매일 오후 10시 <br />
        </span>
        3월 28일(토) ~ 4월 2일(목) <br />
        <span>매일 오후 8시, 10시</span>
      </>
    ),
  },
  appDesc: {
    common: <>피망 쇼다운 홀덤 앱</>,
    mobile: '피망 쇼다운 홀덤 앱',
  },
  partnerTitle: { common: '주최 / 주관' },
  offlineEventTitle: { common: '오프라인 이벤트' },
  offlineDate: { common: '4월 5일(일)' },
  fullEventName: {
    common: (
      <>
        NLH Main Event Day 1<br /> (SHOWDOWN HOLDEM Online Qualifiers)
        <br /> JOPT 2026 Grand Final #01
      </>
    ),
    mobile: 'NLH Main Event Day 1 (SHOWDOWN HOLDEM Online Qualifiers) JOPT 2026 Grand Final #01 ',
  },
  venue: { common: '뉴스톤' },
  venueAddress: {
    common: (
      <>
        서울 강남구 도곡로 1길 14
        <br /> 지하 1층 6, 7호
      </>
    ),
    mobile: <>서울 강남구 도곡로 1길 14 지하 1층 6, 7호</>,
  },
  requestText: {
    common: (
      <>
        자세한 내용은 <br />
        <span onClick={openKakaoLink}>JOPT 카카오톡 채널</span>에 <br />
        문의해주세요!
      </>
    ),
    mobile: (
      <>
        자세한 내용은 <br />
        <span onClick={openKakaoLink}>JOPT 카카오톡 채널</span>에 <br />
        문의해주세요!
      </>
    ),
  },
};
